<template>
  <div>
    <collectionList :search_bar="true" />
  </div>
</template>
<script>
import collectionList from "@/components/portal/global/CollectionList.vue";

export default {
  name: "Collection",
  components: {
    collectionList,
  },
};
</script>
